import React from 'react'
import { ConstituencyContextProvider } from '../../context/constituencyContext'
import Result from '../../components/ConstituencyManagement/Result'
import "../../styles/users.css"

const ConstituencyManagement = () => {
  return (
    // <div>ConstituencyManagement</div>
    <ConstituencyContextProvider>
      <Result />
    </ConstituencyContextProvider>
  )
}

export default ConstituencyManagement